import { Flex, Box, Text } from '@chakra-ui/react'
import { Section, sections } from '../utils'
import { useTranslation } from 'next-i18next/pages'

export const EmptyPlaceholder = ({ game }: { game: Section }) => {
  const { t } = useTranslation()
  const { icon } = sections.find((element) => element.name === game) || { icon: null }

  return (
    <Flex
      flexDir={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      h={'calc(100% - 24px)'}
      bg={'ninja.600'}
      rounded={'24px'}
    >
      <Box boxSize={16} mb={3}>
        {icon}
      </Box>
      <Text maxW={'200px'} textAlign={'center'} fontWeight={700} color={'ninja.200'}>
        {t('verify.add-game-info')}
      </Text>
    </Flex>
  )
}
